<div *ngIf="modo==='normal'">
  <div class="container">
    <div class="busqueda" id="searchInput">
      <div class="spacer"></div>
      <input [(ngModel)]="busquedaActual" (input)="onChange($event.target.value)"
        (keyup.enter)="searchLupa(); $event.target.blur();" (click)="onclick()" class="mysearch"
        placeholder="¿Qué estás buscando..." type="text">
      <div class="search noselect" (click)="onclick(); searchLupa()" onclick="window.scrollTo(0, 0)">
        <i class="mdi mdi-magnify icono-lupa" style="color: white;"></i>
      </div>
    </div>

    <div [@openClose]="desplegado ? 'open' : 'closed'" class="extendible">
      <div class="predictions">
        <productos-view (closeGap)="oncloseGap($event)" *ngFor="let item of resultados; index as i"
          (click)="selecionadoItem(item)" onclick="window.scrollTo(0, 0)"
          [ngClass]="currentSlide==i ? 'seleccionado':''" [articulo]="item" [mode]="'buqueda'">
        </productos-view>
      </div>
    </div>
  </div>
</div>